const CompanyProfileIcons = {
  tick: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="#020617" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`,
  star: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.44826 1.11169C8.36403 0.941261 8.19012 0.833497 8.00001 0.833374C7.83347 0.833374 7.67922 0.916109 7.58693 1.05115L7.55177 1.11169L5.60744 5.04919L1.26076 5.68494C1.0725 5.71245 0.916143 5.84479 0.857436 6.02576C0.798748 6.20676 0.84808 6.40569 0.98439 6.53845L4.12892 9.60095L3.38673 13.9291C3.35467 14.1166 3.43203 14.3065 3.58595 14.4183C3.73991 14.53 3.94397 14.544 4.11232 14.4554L7.99904 12.4115L11.8867 14.4554C12.055 14.5439 12.2592 14.5299 12.4131 14.4183C12.567 14.3065 12.6444 14.1166 12.6123 13.9291L11.8701 9.59998L15.0156 6.53845C15.1519 6.40569 15.2003 6.20672 15.1416 6.02576C15.0829 5.84484 14.9265 5.71245 14.7383 5.68494L10.3916 5.04919L8.44826 1.11169Z" fill="#FCD600"/>
</svg>
`,
lock:`<svg
              width="25"
              height="25"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6667 18.3335V11.6668C11.6667 9.45669 12.5446 7.33708 14.1074 5.77427C15.6702 4.21147 17.7899 3.3335 20 3.3335C22.2101 3.3335 24.3298 4.21147 25.8926 5.77427C27.4554 7.33708 28.3333 9.45669 28.3333 11.6668V18.3335M8.33333 18.3335H31.6667C33.5076 18.3335 35 19.8259 35 21.6668V33.3335C35 35.1744 33.5076 36.6668 31.6667 36.6668H8.33333C6.49238 36.6668 5 35.1744 5 33.3335V21.6668C5 19.8259 6.49238 18.3335 8.33333 18.3335Z"
                stroke="#E55445"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>`
};
export default CompanyProfileIcons;
